import { IPlan } from "../../types";

export * from "./languages";
export * from "./countries";
export * from "./clefs";
export * from "./scales";
export * from "./tempos";
export * from "./levels";
export * from "./folksongClasses";
export * from "./genres";
export * from "./eras";
export * from "./folksongTempos";
export * from "./keys";

export const deparseDescriptions = (descriptions: IPlan["description"]) => {
    let parsedDescriptions: IPlan["description"] = {};
    for (const [lang, description] of Object.entries(descriptions)) {
        parsedDescriptions[lang] = description.replace(/<br\/>/g, "\n");
    }
    return parsedDescriptions;
};
